import { useEffect, useState } from "react";
import calendarIcons from "../../assets/kpi-items/calendaricons.svg";
import projectIcon from "../../assets/kpi-items/projecticon.svg";
import { format, parseISO} from "date-fns";

interface EmailModalProps {
  isOpen: any;
  onClose: any;
  defectsData: any
}

function MailIcon() {
  return (
    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  );
}

function PaperclipIcon() {
  return (
    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
    </svg>
  );
}

function XIcon() {
  return (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  );
}


export default function DefectEmailModal({ isOpen, onClose, defectsData }: EmailModalProps) {


    useEffect(() => {
          if (isOpen) {
              document.body.classList.add("coverflow_hidden_scoll_bdy");
              return () => {
                  document.body.classList.remove("coverflow_hidden_scoll_bdy");
              };
          }
      }, [isOpen]);

        if (!isOpen) return null;

   const result = defectsData?.defects?.defects?.find((i:any) => i.id == isOpen)
  // console.log(result,'result')

  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="bg-white rounded-md shadow-2xl w-full max-w-[991px]">
         <div className="flex flex-col rounded-md">
          
        {/* Header */}
        <div className="flex items-start justify-between px-6 pt-5 pb-0 border-b border-gray-100">
          <div>
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest tracking-widest-icon mb-1 flex items-center gap-1.5">
              <MailIcon />
              Original Email
            </p>
            <h2 className=" mb-0 my-0 font-bold text-xl-dv text-black dark:text-white">
              {result?.screen_name}
            </h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 cta-red transition mt-0.5 ml-4 flex-shrink-0 pt-1"
            aria-label="Close"
          >
            <XIcon />
          </button>
        </div>

        {/* Sender Row */}
        <div className=" max-h-[60vh] overflow-y-auto rounded-md px-6">

          <div className=" py-4 border-b border-gray-100 border-b-custom">
          <div className="flex items-start gap-3">
           <div className="grid items-center gap-3">
             <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-violet-100 dark:bg-slate-600 flex items-center justify-center flex-shrink-0">
                <span className="text-violet-600 font-semibold text-sm">{result?.reporter_name?.charAt(0)}</span>
              </div>
              <div className="min-w-0 grid">
                <p className="my-0 font-bold text-black text-sm">{result?.reporter_name}</p>
                {
                  result?.reporter_email &&  <p className="my-0 text-xs text-gray-500 truncate">{result?.reporter_email}</p>
                }
              </div>
            </div>
            <div className="flex items-center gap-6 profile_info_dv_l">
             
                <span className=" text-xs text-black dark:text-white flex gap-1"> <img src={projectIcon} className="w-4 h-4" alt="" />{result?.agency_name}</span>
                 <span className="text-xs text-black dark:text-white  flex gap-1"><img src={calendarIcons} className="w-4 h-4" alt="" />   {result?.created_on
    ? format(
  new Date(result?.created_on + "Z"),
  "MMM dd, yyyy hh:mm a"
)
    : ""}</span>
                  <span className="text-xs text-black dark:text-white  flex gap-1"><PaperclipIcon /> {result?.attachments_list?.length} Attachment</span>
             
            </div>
           </div>

          </div>
        </div>

        {/* Body */}
        <div className="py-5 text-sm text-gray-700 leading-relaxed space-y-4">
     <div style={{ whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{ __html: result?.description }} />

        </div>

<div className=" grid grid-cols-3 mq1400:grid-3 mq1275:grid-cols-3 mq950:mq1275:grid-cols-2 mq575:mq1275:grid-cols-1 mt-[8px] mb-6 gap-[12px] min-w-full">
            <div className="defact-card-item-dv lightyellow-bg-item">
               <div className="innerdefact-card">
                 <span className=" relative font-semibold  dark:text-white text-black">Steps to Reproduce</span>
                {
                  result?.steps_to_reproduce ?   <p className="text-sm pt-[5px] dark:text-white my-0" style={{ whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{ __html: result?.steps_to_reproduce}} /> : '-'
                }
              
               </div>

            </div>
            
             <div className="defact-card-item-dv lightred-bg-item">
               <div className="innerdefact-card">
                 <span className=" relative font-semibold  dark:text-white text-black">Actual Behaviour</span>
                  {
                  result?.actual_behavior ?   <p className="text-sm pt-[5px] dark:text-white my-0" style={{ whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{ __html: result?.actual_behavior}} /> : '-'
                }
               </div>
            </div>

             <div className="defact-card-item-dv lightgreen-bg-item">
               <div className="innerdefact-card">
                 <span className=" relative font-semibold  dark:text-white text-black">Expected Behaviour</span>
                  {
                  result?.expected_behavior ?   <p className="text-sm pt-[5px] dark:text-white my-0" style={{ whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{ __html: result?.expected_behavior}} /> : '-'
                }
               </div>
            </div>
        </div>


        {
          result?.attachments_list?.length > 0  && 
            <div className="px-6 py-5">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-3 flex items-center gap-1.5">
            <PaperclipIcon />
            Attachments ({result?.attachments_list?.length})
          </p>
          <div className="flex items-center gap-3 border border-gray-200 rounded-xl p-3 hover:bg-gray-50 transition cursor-pointer group w-fit">
         {
         result?.attachments_list?.map((it:any)=>{
          console.log(it,'it')
            return <>
                  {/* File info */}
            <div className="min-w-0 grid items-center gap-0.5">
              <p className="my-0 text-sm font-medium text-gray-800 truncate group-hover:text-indigo-600 transition">
                {it?.file_name}
              </p>
            </div>
            {/* Download icon */}
            <div className="ml-4 flex-shrink-0 text-black transition" 
         onClick={(e) => {
  e.stopPropagation();
  window.open(it?.file_url, "_blank", "noopener,noreferrer");
}
            
            }>
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
            </div></>
          })
         }
      
          </div>
          
        </div>
        
        }
        
      
        </div>
         </div>



      </div>
    </div>
  );
}

